import React from "react";
import { colors } from "app/theme";
import Button from "@mui/material/Button";
import useCookie from "react-use/lib/useCookie";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";

export const CookieSnackbar: React.FC = () => {
  const [hide, setHide] = useCookie("cookieSnackbarHide");

  const handleClose = (
    _event?: Event | React.SyntheticEvent,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setHide("true");
  };

  return (
    <Snackbar
      onClose={handleClose}
      open={hide !== "true"}
      autoHideDuration={null}
      ClickAwayListenerProps={{ mouseEvent: false }}
      message="The website makes use of cookies. Review data privacy for more details."
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      sx={{
        width: "100%",
        bottom: "0px !important",
        ".MuiSnackbarContent-root": {
          width: "1340px",
          fontSize: "16px",
          fontWeight: "700",
          justifyContent: "center",
          color: colors.text.title,
          backgroundColor: colors.secondary.lightGrey,
        },
        ".MuiSnackbarContent-action": {
          margin: "0px 0px 0px 16px !important",
          button: {
            padding: "4px 16px",
          },
        },
        "@media (max-width: 1400px)": {
          ".MuiSnackbarContent-root": {
            width: "100%",
            display: "block",
          },
          ".MuiSnackbarContent-action": {
            padding: 0,
            margin: "0px !important",
            button: {
              width: "100%",
            },
          },
        },
      }}
      action={
        <Button variant="contained" onClick={handleClose}>
          Accept
        </Button>
      }
    />
  );
};
